import styled from 'styled-components';

export const Container = styled.svg`
&:hover{
    cursor: pointer;
  }
`;
